"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.VoiceOrb = exports.getBarStyle = exports.VoiceAura = void 0;
var react_1 = __importDefault(require("react"));
var inset = function (n) { return ({
    position: 'absolute',
    top: n,
    right: n,
    bottom: n,
    left: n,
}); };
var round = __assign(__assign({}, inset(0)), { borderRadius: '50%' });
var radial = function (color) {
    return "radial-gradient(closest-side," + color + ",transparent)";
};
var Blob = function (_a) {
    var place = _a.place, color = _a.color, blur = _a.blur, animation = _a.animation;
    return (react_1["default"].createElement("span", { style: __assign({ position: 'absolute', borderRadius: '50%', background: radial(color), filter: "blur(" + blur + "px)", animation: animation }, place) }));
};
var square = function (size) { return ({
    width: size,
    height: size,
}); };
// One blob orbiting inside the orb body.
var Orbit = function (_a) {
    var seconds = _a.seconds, _b = _a.reverse, reverse = _b === void 0 ? false : _b, place = _a.place, color = _a.color, blur = _a.blur, animation = _a.animation;
    return (react_1["default"].createElement("span", { style: __assign(__assign({}, inset(0)), { animation: "vw-spin " + seconds + "s linear infinite" + (reverse ? ' reverse' : '') }) },
        react_1["default"].createElement(Blob, { place: place, color: color, blur: blur, animation: animation })));
};
// Soft brand glow behind the orb, centred on `top` (px from the screen top).
exports.VoiceAura = function (_a) {
    var theme = _a.theme, config = _a.config, top = _a.top;
    var aura = config.aura;
    var swirl = config.orb ? config.orb.swirl : 0;
    return (react_1["default"].createElement("div", { "aria-hidden": "true", style: {
            position: 'absolute',
            left: '50%',
            top: top,
            width: 480,
            height: 480,
            margin: '-240px 0 0 -240px',
            pointerEvents: 'none',
            transform: "scale(" + aura.scale + ")",
            opacity: aura.opacity,
            filter: "saturate(" + aura.saturate + ")",
            transition: 'transform .9s cubic-bezier(.4,0,.2,1), opacity .7s ease, filter .7s ease',
        } },
        react_1["default"].createElement("div", { style: __assign(__assign({}, round), { background: "radial-gradient(closest-side," + theme.auraCore + "," + theme.auraEdge + " 55%,transparent)", animation: "vw-aura " + aura.seconds + "s ease-in-out infinite" }) }),
        react_1["default"].createElement("div", { style: __assign(__assign({}, inset(0)), { animation: 'vw-spin 26s linear infinite' }) },
            react_1["default"].createElement(Blob, { place: __assign({ left: '4%', top: '12%' }, square('58%')), color: theme.auraAlt, blur: 20, animation: "vw-drift 13s ease-in-out infinite" }),
            react_1["default"].createElement(Blob, { place: __assign({ right: '2%', top: '38%' }, square('50%')), color: theme.auraB, blur: 24, animation: "vw-drift2 17s ease-in-out -5s infinite" }),
            react_1["default"].createElement(Blob, { place: __assign({ left: '26%', bottom: '4%' }, square('44%')), color: theme.auraC, blur: 22, animation: "vw-drift2 21s ease-in-out -11s infinite reverse" })),
        react_1["default"].createElement("div", { style: __assign(__assign({}, inset(29)), { opacity: swirl, transition: 'opacity 1.2s ease', animation: 'vw-spin 9s linear infinite reverse' }) },
            react_1["default"].createElement(Blob, { place: __assign({ left: '10%', top: '20%' }, square('46%')), color: theme.auraAlt, blur: 18, animation: "vw-drift2 6s ease-in-out infinite" }),
            react_1["default"].createElement(Blob, { place: __assign({ right: '8%', bottom: '16%' }, square('42%')), color: theme.auraB, blur: 18, animation: "vw-drift 7s ease-in-out -3s infinite" }))));
};
var RIPPLE_DELAYS = ['0s', '0.8s', '1.6s'];
var BAR_HEIGHTS = [14, 22, 30, 40, 48, 40, 30, 22, 14];
var BAR_KEYS = ['b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9'];
exports.getBarStyle = function (mode, i, color) {
    var base = BAR_HEIGHTS[i];
    var width = 4;
    var height = base;
    var opacity = 1;
    var animation = 'none';
    var delay = 0;
    if (mode === 'rest') {
        height = base * 0.7;
        opacity = 0.9;
    }
    else if (mode === 'listen') {
        animation = 'vw-breathe 2.4s ease-in-out infinite';
        delay = i * 0.12;
    }
    else if (mode === 'speak') {
        height = Math.min(base * 1.12, 56);
        animation = 'vw-talk .9s ease-in-out infinite';
        delay = Math.abs(i - 4) * 0.11;
    }
    else if (mode === 'dots') {
        height = 6;
        width = 6;
        animation = 'vw-dot 1.2s ease-in-out infinite';
        delay = i * 0.1;
    }
    else if (mode === 'wave') {
        height = 6;
        width = 6;
        animation = 'vw-wave 1.2s ease-in-out infinite';
        delay = i * 0.09;
    }
    else if (mode === 'flat') {
        height = 4;
        opacity = 0.45;
    }
    return {
        display: 'block',
        flex: 'none',
        width: width,
        height: Math.round(height),
        borderRadius: 999,
        background: color,
        opacity: opacity,
        animation: animation,
        animationDelay: delay.toFixed(2) + "s",
        transition: 'height .5s cubic-bezier(.4,0,.2,1), width .5s cubic-bezier(.4,0,.2,1), opacity .5s ease',
    };
};
// The 152px orb: frosted brand blobs, rim light, spinner ring and bars.
exports.VoiceOrb = function (_a) {
    var theme = _a.theme, config = _a.config;
    var orb = config.orb;
    var _b = theme.orbBlobs, c1 = _b[0], c2 = _b[1], c3 = _b[2], c4 = _b[3], c5 = _b[4];
    var mask = 'radial-gradient(farthest-side,transparent calc(100% - 1.8px),#000 calc(100% - 1.3px))';
    return (react_1["default"].createElement("div", { "aria-hidden": "true", style: {
            position: 'relative',
            width: 152,
            height: 152,
            flex: 'none',
            display: 'grid',
            placeItems: 'center',
            transform: "scale(" + orb.scale + ")",
            transition: 'transform .8s cubic-bezier(.4,0,.2,1)',
        } },
        react_1["default"].createElement("span", { style: __assign(__assign({}, inset(-10)), { borderRadius: '50%', opacity: orb.spinner ? 1 : 0, transition: 'opacity .6s ease' }) },
            react_1["default"].createElement("span", { style: __assign(__assign({}, round), { background: "conic-gradient(from 0deg,transparent 0deg," + theme.ink + " 80deg,transparent 150deg)", WebkitMask: mask, mask: mask, animation: 'vw-spin 1.2s linear infinite' }) })),
        react_1["default"].createElement("span", { style: __assign(__assign({}, round), { opacity: orb.ripple ? 1 : 0, transition: 'opacity .5s ease', pointerEvents: 'none' }) }, RIPPLE_DELAYS.map(function (delay) { return (react_1["default"].createElement("span", { key: delay, style: __assign(__assign({}, round), { border: "1.5px solid " + theme.tint32, background: theme.tint05, animation: "vw-ripple 2.4s cubic-bezier(.2,.6,.3,1) " + delay + " infinite" }) })); })),
        react_1["default"].createElement("span", { style: __assign(__assign({}, round), { boxShadow: "0 18px 46px " + theme.orbHalo + ", 0 0 64px " + theme.orbHalo2, transform: "scale(" + orb.cloudScale + ")", opacity: orb.cloudOpacity, filter: "saturate(" + orb.cloudSaturate + ")", transition: 'transform .9s cubic-bezier(.4,0,.2,1), opacity .9s ease, filter .9s ease' }) },
            react_1["default"].createElement("span", { style: __assign(__assign({}, round), { animation: orb.core }) },
                react_1["default"].createElement("span", { style: __assign(__assign({}, round), { overflow: 'hidden', background: theme.orbBase }) },
                    react_1["default"].createElement("span", { style: inset(14) },
                        react_1["default"].createElement(Orbit, { seconds: 16, place: __assign({ left: '-6%', top: '6%' }, square('70%')), color: c1, blur: 9, animation: "vw-drift2 9s ease-in-out infinite" }),
                        react_1["default"].createElement(Orbit, { seconds: 21, reverse: true, place: __assign({ left: '40%', top: '-4%' }, square('66%')), color: c2, blur: 9, animation: "vw-drift2 11s ease-in-out infinite" }),
                        react_1["default"].createElement(Orbit, { seconds: 18, place: __assign({ left: '30%', top: '44%' }, square('72%')), color: c3, blur: 9, animation: "vw-drift2 13s ease-in-out infinite" }),
                        react_1["default"].createElement(Orbit, { seconds: 25, reverse: true, place: __assign({ left: '-4%', top: '46%' }, square('58%')), color: c4, blur: 9, animation: "vw-drift2 10s ease-in-out infinite" }),
                        react_1["default"].createElement(Orbit, { seconds: 13, place: __assign({ left: '46%', top: '28%' }, square('46%')), color: c5, blur: 9, animation: "vw-drift2 8s ease-in-out infinite" }),
                        react_1["default"].createElement("span", { style: __assign(__assign({}, inset(0)), { opacity: orb.fast, transition: 'opacity 1s ease' }) },
                            react_1["default"].createElement(Orbit, { seconds: 3.4, place: __assign({ left: '10%', top: '14%' }, square('54%')), color: c2, blur: 9, animation: "vw-drift2 4s ease-in-out infinite" }),
                            react_1["default"].createElement(Orbit, { seconds: 4.2, reverse: true, place: __assign({ left: '40%', top: '40%' }, square('50%')), color: c3, blur: 9, animation: "vw-drift2 5s ease-in-out infinite" }))),
                    react_1["default"].createElement("span", { style: __assign(__assign({}, round), { background: theme.frost, WebkitBackdropFilter: 'blur(20px) saturate(170%)', backdropFilter: 'blur(20px) saturate(170%)' }) }),
                    react_1["default"].createElement("span", { style: __assign(__assign({}, round), { background: "radial-gradient(circle at 50% 46%," + theme.glow + ",transparent 46%)" }) }),
                    react_1["default"].createElement("span", { style: __assign(__assign({}, round), { background: 'radial-gradient(circle at 50% 18%,rgba(255,255,255,.28),transparent 46%),' +
                                ("radial-gradient(circle at 50% 108%," + theme.orbShade + ",transparent 58%)") }) }))),
            react_1["default"].createElement("span", { style: __assign(__assign({}, round), { boxShadow: theme.rim }) })),
        react_1["default"].createElement("span", { style: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5,
                height: 64,
            } }, BAR_KEYS.map(function (key, i) { return (react_1["default"].createElement("span", { key: key, style: exports.getBarStyle(config.bars, i, theme.ink) })); }))));
};
